import { Injectable } from '@angular/core';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Injectable({
  providedIn: 'root'
})
export class DataAccessDocumentsTrackingSegmentService {
  docsToTrack = {
    rg: 'rg',
    cpf: 'cpf',
    endereco: 'comprovante_endereco',
    pis: 'pis',
    'infos-pessoais': 'info_pessoais',
    escolaridade: 'comprovante_escolaridade',
    estrangeiro: 'doc_estrangeiro',
    'certidao-casamento': 'certidao_casamento',
    'certidao-nascimento': 'certidao_nascimento',
    'certidao-divorcio': 'certidao_divorcio',
    'certidao-viuvo': 'certidao_viuvez',
    'certidao-separado': 'certidao_separacao',
    'certidao-uniao-estavel': 'certidao_uniao_estavel',
    responsaveis: 'responsaveis_legais',
    dependentes: 'dependentes',
    'laudo-medico': 'laudo_medico',
    address: 'comprovante_endereco',
    'comprovante-vacinacao-covid': 'covid',
    'exame-medico': 'exame_medico'
  };

  public shouldTrackDocument(): boolean {
    return !!this.docsToTrack[this.getLocationDocument()];
  }

  public getLocationDocument(): string {
    const locationUrl = window.location.pathname;
    let locationDocument = locationUrl.substring(locationUrl.lastIndexOf('/document/') + 10);
    locationDocument =
      locationDocument.indexOf('/new') > -1 ? locationDocument.substring(0, locationDocument.indexOf('/new')) : locationDocument;
    return locationDocument;
  }

  public getLocationDocumentAlias(): string {
    let locationDocument = this.docsToTrack[this.getLocationDocument()];
    if (locationDocument == 'comprovante_endereco') {
      return SessionStorage.getItem('screen') || locationDocument;
    }
    return locationDocument;
  }

  public getOrganizationName(): string {
    const organizationName = SessionStorage.getItem('organizationName');
    return organizationName ? organizationName : '';
  }

  public getAccountName(): any {
    const infos = SessionStorage.getItem('currentAccountName');
    return infos ? infos : '';
  }

  public getEventTitle() {
    return {
      save: 'People - Candidate Admission Document - Save Button Click',
      back: 'People - Candidate Admission Document - Back Button Click',
      upload: 'People - Candidate Admission Document - Take Photo Link Click',
      finishLater: 'People - Candidate Admission Document - Finish Later Button Click',
      pageView: 'People - Candidate Admission Document - Page View',
      signedIn: 'People - Candidate Admission - User Signed In',
      signedUp: 'People - Candidate Admission - User Signed Up'
    };
  }

  public getProperties(location?) {
    return {
      organization: this.getOrganizationName(),
      account: this.getAccountName(),
      location: location || this.getLocationDocumentAlias()
    };
  }
}
